import createPubSub from "pub-sub-es";
const MessageBroker = createPubSub();
export default MessageBroker;
